import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as EditPencilIcon } from '../../../assets/images/EditPencilIcon.svg';
import urls from '../../../routing/urls';

import styles from './ExperientialRewardDetails.module.scss';

const FieldContent = ({ label, value, noneText }) => (
  <div className={styles.fieldContent}>
    <div className={styles.label}> {label} </div>
    <div className={styles.detail}> {value || noneText} </div>
  </div>
);

const ExperientialRewardDetails = () => {
  const { t } = useTranslation('common');
  const details = useSelector((state) => state.userReducer.expRewardDetails);
  const navigate = useNavigate();
  const noneText = t('none');

  return (
    <div className={styles.container}>
      <div className={styles.topRow}>
        <FieldContent label={t('experientialRewardDetails.fullName')} value={details.name} noneText={noneText} />
        <button type="button" className={styles.editBtn} onClick={() => navigate(urls.experientialRewardsDetails)}>
          <EditPencilIcon />
        </button>
      </div>
      <FieldContent label={t('experientialRewardDetails.recipientEmail')} value={details.email} noneText={noneText} />
      <FieldContent
        label={t('experientialRewardDetails.streetAddress')}
        value={details.street_address}
        noneText={noneText}
      />
      <FieldContent label={t('experientialRewardDetails.unitSuite')} value={details.unit} noneText={noneText} />
      <div className={styles.twoFieldContent}>
        <FieldContent label={t('experientialRewardDetails.city')} value={details.city} noneText={noneText} />
        <FieldContent label={t('experientialRewardDetails.state')} value={details.state} noneText={noneText} />
      </div>
      <div className={styles.twoFieldContent}>
        <FieldContent label={t('experientialRewardDetails.country')} value={details.country} noneText={noneText} />
        <FieldContent
          label={t('experientialRewardDetails.postalCode')}
          value={details.postal_code}
          noneText={noneText}
        />
      </div>
      <FieldContent
        label={t('experientialRewardDetails.phoneNumber')}
        value={details.phone_number}
        noneText={noneText}
      />
      <FieldContent
        label={t('experientialRewardDetails.additionalDeliveryInstructions')}
        value={details.delivery_instructions}
        noneText={noneText}
      />
    </div>
  );
};

export default ExperientialRewardDetails;
